
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.833 10c1.442-3.658 5-6.25 9.167-6.25s7.725 2.592 9.167 6.25c-1.442 3.658-5 6.25-9.167 6.25S2.275 13.658.833 10zm16.517 0A8.142 8.142 0 0010 5.417 8.142 8.142 0 002.65 10 8.142 8.142 0 0010 14.583 8.142 8.142 0 0017.35 10zM10 7.917a2.084 2.084 0 11-.002 4.168A2.084 2.084 0 0110 7.917zM6.25 10A3.756 3.756 0 0110 6.25 3.756 3.756 0 0113.75 10 3.756 3.756 0 0110 13.75 3.756 3.756 0 016.25 10z","fill":"#1D3C6F"}})])
          )
        }
      }
    